module.exports = __webpack_public_path__ + "assets/img/tab_img_xyy.55c447fa.png";